import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useUiPrefsStore } from '../../stores/uiPrefsStore';

/** Quick light/dark toggle for the top bar. Cycles modern ↔ dark.
 * Power users get the full theme picker (sepia / retro) in /settings. */
export default function HeaderThemeToggle() {
  const theme = useUiPrefsStore((s) => s.theme);
  const setTheme = useUiPrefsStore((s) => s.setTheme);
  const isDark = theme === 'dark';

  return (
    <Tooltip
      title={isDark ? 'מצב בהיר' : 'מצב כהה — נעים לעיניים'}
      arrow
    >
      <IconButton
        size="small"
        onClick={() => setTheme(isDark ? 'modern' : 'dark')}
        sx={{ color: 'text.secondary' }}
      >
        {isDark ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  );
}
